var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSunglasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sunglasses"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.125 11.0365V12.9115C8.125 13.6574 7.82868 14.3728 7.30124 14.9002C6.77379 15.4277 6.05842 15.724 5.3125 15.724C4.56658 15.724 3.85121 15.4277 3.32376 14.9002C2.79632 14.3728 2.5 13.6574 2.5 12.9115V11.0365",
    stroke: "url(#paint0_linear_7937_33992)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 11.0365V12.9115C17.5 13.6574 17.2037 14.3728 16.6762 14.9002C16.1488 15.4277 15.4334 15.724 14.6875 15.724C13.9416 15.724 13.2262 15.4277 12.6988 14.9002C12.1713 14.3728 11.875 13.6574 11.875 12.9115V11.0365",
    stroke: "url(#paint1_linear_7937_33992)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.625 3.849C15.8715 3.84797 16.1158 3.89576 16.3438 3.98962C16.5717 4.08348 16.7788 4.22155 16.9531 4.39587C17.1274 4.57019 17.2655 4.7773 17.3594 5.00525C17.4532 5.2332 17.501 5.47748 17.5 5.724V11.0365H2.5V5.724C2.49897 5.47748 2.54676 5.2332 2.64062 5.00525C2.73448 4.7773 2.87256 4.57019 3.04687 4.39587C3.22119 4.22155 3.4283 4.08348 3.65625 3.98962C3.8842 3.89576 4.12848 3.84797 4.375 3.849",
    stroke: "url(#paint2_linear_7937_33992)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.125 11.0365L16.8281 14.7396",
    stroke: "url(#paint3_linear_7937_33992)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.75 11.0365L7.45313 14.7396",
    stroke: "url(#paint4_linear_7937_33992)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7937_33992",
    x1: 6.93182,
    y1: 15.3689,
    x2: 4.1374,
    y2: 10.5559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7937_33992",
    x1: 16.3068,
    y1: 15.3689,
    x2: 13.5124,
    y2: 10.5559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7937_33992",
    x1: 14.3182,
    y1: 10.492,
    x2: 11.3543,
    y2: 1.61383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7937_33992",
    x1: 16.0426,
    y1: 14.4591,
    x2: 13.658,
    y2: 11.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7937_33992",
    x1: 6.66761,
    y1: 14.4591,
    x2: 4.28303,
    y2: 11.0365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECB917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunglasses);
export default __webpack_public_path__ + "static/media/sunglasses.2106c7de7a818e186b4207289d0ec1ca.svg";
export { ForwardRef as ReactComponent };